import Component from '../../classes/Component';
import {$dom} from '../../helpers/dom';
import {$style} from '../../helpers/style';
import {isElement} from '../../helpers/_utilities';
import is from 'is_js';
import {$events} from '../../helpers/events';
import variables from '../../variables';

const {callAll, get, attr, addClass, removeClass} = $dom;
const {offset, set, remove} = $style;

export default function productionSection(rootId = 'home-production') {

  const
    pointAttr = 'data-production-point',
    iconAttr = 'data-production-control-icon',
    controlAttr = 'data-production-control',
    contentAttr = 'data-production-content',
    circlePartAttr = 'data-production-circle-part'
  ;

  const getBoundPoint = control => get(`[${pointAttr}=${attr(control, controlAttr)}]`, `#${rootId}`);

  const clearControlsPosition = () => {
    callAll(`#${rootId} [${controlAttr}]`, control => remove(control, ['left', 'top']))
  };

  const updateControlsPosition = () => {
    callAll(`#${rootId} [${controlAttr}]`, control => {

      const
        point = getBoundPoint(control),
        icon = get(`[${iconAttr}]`, control)
      ;

      remove(control, ['left', 'top']);

      if (isElement(point) && isElement(icon)) {
        const
          {left: pointLeft, top: pointTop} = offset(point),
          {left: iconLeft, top: iconTop} = offset(icon),
          {width: pointWidth, height: pointHeight} = point.getBoundingClientRect()
        ;

        if (
          is.number(pointLeft)
          && is.number(pointTop)
          && is.number(iconLeft)
          && is.number(iconTop)
        ) {
          set(control, {
            left: (pointLeft - iconLeft - (icon.offsetWidth / 2) + (pointWidth / 2)) + 'px',
            top: (pointTop - iconTop - (icon.offsetHeight / 2) + (pointHeight / 2)) + 'px'
          })
        }
      }
    })
  };

  const changeCategory = (category) => {

    callAll(`#${rootId} [${contentAttr}]`, content => {
      if (attr(content, contentAttr) === category) {
        addClass(content, variables.classNames.active);
      } else {
        removeClass(content, variables.classNames.active)
      }
    });

    callAll(`#${rootId} [${controlAttr}]`, control => {
      const a = attr(control, controlAttr);

      if (a === category) {
        addClass(control, variables.classNames.active);
      } else {
        removeClass(control, variables.classNames.active)
      }

      callAll(`[${circlePartAttr}]`, part => {
        const circleA = attr(part, circlePartAttr);

        if (Boolean(circleA)) {
          if (JSON.parse(circleA).includes(category)) {
            addClass(part, variables.classNames.active)
          } else {
            removeClass(part, variables.classNames.active)
          }
        }

      })

    })

  };

  const handleCategoryChangeClick = ({target}) => {

    const button = target.closest(`[${controlAttr}]`);

    if (isElement(button) && variables.windowWidth >= variables.breakpoints.lg) changeCategory(attr(button, controlAttr))
  };

  const checkScreenWidth = () => {
    if (variables.windowWidth >= variables.breakpoints.lg) {
      updateControlsPosition();
    } else {
      clearControlsPosition()
    }
  };

  return new Component({
    name: 'homeProduction',
    requiredSelector: `#${rootId}`,
    rootElementId: rootId,
    onCreate() {

    },
    onInit() {
      const rootInitCategory = attr(`#${rootId}`, 'data-init-category');

      if (rootInitCategory) {
        changeCategory(rootInitCategory)
      } else {
        const firstButton = get(`[${controlAttr}]`);
        if (isElement(firstButton)) changeCategory(attr(firstButton, controlAttr))
      }

      checkScreenWidth();

      $events.delegate
        .on('click tap', `[${controlAttr}]`, handleCategoryChangeClick)
        .on(variables.customEventNames.resize, window, checkScreenWidth)
      ;
    },
    onDestroy() {
      $events.delegate
        .off('click tap', `[${controlAttr}]`, handleCategoryChangeClick)
        .off(variables.customEventNames.resize, window, checkScreenWidth)
      ;
    }
  })
}